import React from "react";
import Breadclumbs from "./Breadclumbs";
import Headlins from "./Headlins";
import Filtercategoryitem from "./Filtercategoryitem";
import Cart from "./Cart";

function Shop() {
  return (
    <div>
      <Breadclumbs />
      <Headlins suptitle={"Shop by category"} title={"Shop by category"} />
      <div className="Filter-Category">
        <Filtercategoryitem start={"Vegetarian"} />
        <Filtercategoryitem start={"Meal "} />
        <Filtercategoryitem start={"Chicken"} />
        <Filtercategoryitem start={"Dubble"} />
      </div>
      <div className="shop-items">
        <Cart />
        <Cart />
        <Cart />
        <Cart />
        <Cart />
        <Cart />
        <Cart />
        <Cart />
        <Cart />
        <Cart />
        <Cart />
        <Cart />
        <Cart />
        <Cart />
        <Cart />
      </div>
    </div>
  );
}

export default Shop;
